const LOOPBACK_HOSTNAMES = new Set(["localhost", "127.0.0.1", "::1", "[::1]"])

export function isLoopbackHostname(hostname: string) {
  return LOOPBACK_HOSTNAMES.has(hostname.toLowerCase())
}

export function isFrontendArtifactReloadSupported(
  hostname = typeof window === "undefined" ? "" : window.location.hostname,
) {
  return Boolean(hostname) && !isLoopbackHostname(hostname)
}
